module.exports = __webpack_public_path__ + "img/liushui (8).3141e060.png";